import React from "react";
import 'animate.css';

// Add Personal Image to be used in the About me section
import PersonalImage from "../img/IMG_20180929_175803.jpg";
import Resume from "../pdf/JasonWilliamsResume.pdf";


function About() {
    return (
        <section className="about">
    <h1 className="animate__animated animate__slideInDown">
        Ab<span className="underline">out</span>
    </h1>
    <div>
        <p className="animate__animated animate__fadeIn animate__delay-1s">
            I've always been fascinated by how websites are designed and built. From simple text pages to interactive web applications, my curiosity led me to pursue a degree in <b>Interactive Media Design - Web from Georgian College.</b>
        </p>
        <p className="animate__animated animate__fadeIn animate__delay-1s">Today, I specialize in:</p>
        <ul className="animate__animated animate__fadeIn animate__delay-1s">
            <li>HTML, CSS, JavaScript, React</li>
            <li>Figma, Adobe Illustrator, Adobe Photoshop</li>
            <li>UI/UX best practices, SEO, social media content creation, Google Analytics</li>
        </ul>
        <p className="animate__animated animate__fadeIn animate__delay-1s">
            I love turning ideas into functional, visually engaging websites. Web development is where creativity and problem-solving meet, and I'm passionate about creating user-friendly and aesthetically pleasing sites that deliver seamless experiences.
        </p>
        <p className="animate__animated animate__fadeIn animate__delay-1s">
            I'm always learning new techniques and exploring trends in web development. If you're looking for a creative, dedicated web developer, <b>let's connect and bring your vision to life!</b>
        </p>
        <figure>
            <img
                className="img-fluid mx-auto d-block animate__animated animate__fadeIn animate__delay-2s"
                src={PersonalImage}
                width="20%"
                alt="A professional portrait or logo of the developer"
            />
        </figure>
    </div>
    <div>
        <a href="/contact" id="contact-link">
            <button className="animate__animated animate__fadeIn animate__delay-2s">Contact</button>
        </a>
        <a target="_blank" href={Resume} id="skills-link">
            <button className="animate__animated animate__fadeIn animate__delay-2s">Resumé</button>
        </a>
    </div>
</section>

    );
}
export default About;